<template>
  <div class="page-about">

    <div v-if="loading === false" class="container slick-wrapper" data-aos="fade-in" data-aos-once="true">
      <slick ref="slick" :options="slickOptions">
        <div v-for="item in items" v-bind:key="item.title" :caption="item.title" :href="item.image.path" :src="item.image.path"><img v-if="isDesktop" :src="item.image.path" /><img v-else :src="item.image_mobile.path" /></div>
        <!-- </lightbox> -->
      </slick>
    </div>

    <div v-if="loading === false" class="container about-container">
      <div class="title">
        &nbsp;
      </div>
      <div class="columns is-centered">
        <div class="column content is-2" data-aos="fade-up" data-aos-once="true">
          <h1 class="title" v-html="paragraph.title">
            {{ paragraph.title }}
          </h1>
        </div>
        <div class="column content is-3" data-aos="fade-up" data-aos-once="true" v-if="false">
          <p class="key">Chinese, Tibetan and Mongolian antiques, modern oriental reproduction furniture as well as lighting, carvings, figurines and accessories.</p>
        </div>
        <div class="column content is-8" data-aos="fade-up" data-aos-once="true" v-html="paragraph.content">
          <!-- <p class="paragraph">Lasting Impressions is a leading supplier of authentic restored Chinese antiques and exclusive modern oriental wooden furniture in Malaysia since 1991. The idea behind our company was to build a brand that encompassed all the little things that we thought were important to us and overlooked by many.</p>

          <p class="paragraph">Our current collection features the finest selection of classical and modern Chinese furniture. Every unique item here is carefully and individually selected with today’s modern home in mind and restored to ensure the highest available quality.</p>

          <p class="paragraph">Lasting Impressions’ understanding of its customers is reflected in its meticulous attention to detail, taking into account a wide range of lifestyles and interests. Every item we sell, from a hand-painted porcelain table lamp to a console table, is representative of a unifying design and quality philosophy. It must be aesthetically appealing, functional and offer remarkable value. In short, it must satisfy your needs today. And tomorrow. To maximize the use of space. To be adaptable to different environments. And finally, to communicate boldly your appreciation of the finer things in life.</p>

          <p class="paragraph">Lasting Impressions works with many interior designers and decorators across Malaysia. Our vast collections, our staff’s wealth of knowledge of products and available resources will be able to provide solutions to clients’ needs.</p>

          <p class="paragraph">We push to exceed expectations by providing the best items and service to all our clients. Every product from us is the result of our passion to do better. It is our culture and goal and it will always be our way.</p> -->
        </div>
      </div>

      <div class="control notification is-danger" v-if="error">
        <button class="delete" @click="error = undefined"></button>
        {{ error }}
      </div>
    </div>

  </div>
</template>

<script>
  // import img01 from '@/assets/lasting_impressions_banner_2.jpg'
  // import img01m from '@/assets/lasting_impressions_banner_2_m.jpg'
  import imgAbout from '@/assets/lasting_impressions_about_d.jpg'
  import imgAboutm from '@/assets/lasting_impressions_about_m.jpg'
  import Slick from 'vue-slick'
  import Lightbox from 'vue-lightbox'

  import auth from '@/apis/Auth'
  import ShowDown from 'showdown'

  export default {
    name: 'landing',
    components: {
      Slick,
      Lightbox
    },
    data () {
      return {
        isDesktop: true,
        paragraph: {
          title: '',
          content: ''
        },
        slickOptions: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          responsive: [
            {
              breakpoint: 1008,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
              }
            }, {
              // 768 = tablet (not break yet)
              breakpoint: 769,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: true
              }
            }, {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: true
              }
            }
          ]
        },
        images: [
          {
            title: 'Showcase 01',
            src: imgAbout,
            srcMobile: imgAboutm,
            desc: '',
            other: ''
          }
        ],
        items: [],
        error: undefined,
        loading: true
      }
    },
    computed: {
    },
    watch: {
    },
    created () {
      console.log('created About.vue')
    },
    mounted () {
      console.log('mounted About.vue')
      // window.GA('send', 'pageview')

      // on event resize
      this.isDesktop = (window.innerWidth >= 768)
      window.addEventListener('resize', function (event) {
        // console.log('on viewport change')
        this.isDesktop = (event.target.innerWidth >= 768)
      }.bind(this))

      this.items = []
      this.paragraph.content = ''
      this.paragraph.title = ''
      this.getAbout((data) => {
        if (data.length > 0) {
          var content = data[0].content
          var converter = new ShowDown.Converter()
          var html = converter.makeHtml(content)
          this.paragraph.content = html
          this.paragraph.title = data[0].title
          this.items.push(data[0])
        } else {
          this.error = 'Invalid content.'
        }
      }, (error) => {
        console.log(error)
      })
    },
    methods: {
      onScrollTo: function (name) {
        this.$scrollTo('#' + name)
      }.bind(this),

      next () {
        if (this.$refs.slick) {
          this.$refs.slick.next()
        }
      },
      prev () {
        if (this.$refs.slick) {
          this.$refs.slick.prev()
        }
      },
      reInit () {
        if (this.$refs.slick) {
          this.$refs.slick.reSlick()
        }
      },
      getAbout (onComplete, onError) {
        this.loading = true
        auth.about()
        .then(data => {
          console.log('get about')
          console.log(data)
          if (onComplete) {
            onComplete(data)
          }
          this.loading = false
          this.$nextTick(function () {
            this.reInit()
          })
          this.reInit()
        })
        .catch(error => {
          console.log('invalid get about', error)
          this.error = error.error
          if (onError) {
            onError(error)
          }
          this.loading = false
        })
      }
    }
  }
</script>

<style lang="scss">
@import "../assets/app_setting.scss";
@import "../styles/carousel_slick.scss";

.page-about {
}

.about-container {
  padding: 15px;

  @media screen and (min-width: $desktop) {
    padding: 0px;
  }
}

.content {
  .title {

  }

  .key {
    color: gray;
    padding-right: 0px;

    @media screen and (min-width: $desktop) {
      padding-right: 30px;
    }
  }

  p {
    text-align: justify;
    color: gray;
  }
}

</style>



// WEBPACK FOOTER //
// About.vue?abdcb932